import React from 'react'
import css from '../css/button.module.css';

const Button = ({text,click,className}) => {
  return (
        <button className={`${css.button} ${className?className:''}`} onClick={click}>{text}</button>
    )
}

export default Button